import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import * as resources from './locales'

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
